




























































import Component from "vue-class-component";
import BaseError from './BaseError'

@Component({})
export default class CompatibilityError extends BaseError {

}
